import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 171 132",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m110.023 0-5.681 39.755L154.057.585 171 23.218l-54.163 42.674 42.109 42.82-23.411 22.634-38.522-39.172L91.323 132H60.968l5.69-39.825-49.715 39.172L0 108.712l54.162-42.675-42.108-42.818L35.465.584l38.521 39.17L79.666 0h30.357zm6.586 65.663c-15.426-15.686-42.062-15.686-61.97 0l-.476.373.228.232c15.426 15.686 42.062 15.686 61.97 0l.476-.374z",
  fill: "#0B042B",
  "fill-rule": "nonzero"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }